import storage from 'redux-persist/lib/storage';

const persistConfig = {
  key: 'root',
  storage,
  // Add any other config options here
};

export default persistConfig;